'use strict'
import './css/styles.scss'

import adminMenu from '@elasticms/admin-menu'
import toc from '@smals-webagency/toc'
import back2top from './js/back2top'
import ajaxSearch from './js/ajax-search'
import externalLink from './js/external-link'
import form from './js/form'
import contentWysiwyg from './js/content-wysiwyg'
import searchModal from './js/search-modal'
import datepicker from './js/datepicker'
import {NavBar} from './js/navbar'

import Cookies from 'js-cookie';
import cookiesBanner from "./js/cookiesBanner";

const $ = require('jquery')
window.$ = $
window.jQuery = $
require('bootstrap')

const translations = JSON.parse(document.body.getAttribute('data-translations'))

adminMenu('esm_demo_admin', '<span>' + (translations.back_to_ems === undefined ? 'Back to ems' : translations.back_to_ems) + '</span>')
ajaxSearch()
externalLink()
form()
contentWysiwyg()
searchModal()

const navBar = new NavBar()
navBar.activateBestItem()

console.log('Demo website loaded!')

$(function() {
    back2top(200)

    cookiesBanner(Cookies);

    datepicker()

    toc({
        contentElementId: 'page-content',
        listTag: 'nav',
        listClass: 'nav flex-column',
        anchorClass: 'nav-link smoothscroll',
        headings: 'h2',
        scrollspy: true
    })
    // align filters desktop & mobile
    $('.search-filter-group input[type="checkbox"]').change(function () {
        $('input[value="' + $(this).val() + '"]').prop("checked", this.checked);
    });

    /* START lexion */
    var url = $('#content').data('ajax-lexicon');
    self.xhr = $.getJSON(url, {}).done(function (data) {
        $('#content').find('a[href^="ems://object:glossary:"]').each(function () {
            var emslink = this.getAttribute('href').substr('ems://object:'.length)

            if (data.hasOwnProperty(emslink)) {
                this.setAttribute('href', '#')
                this.setAttribute('class', 'lexique')
                this.dataset.toggle = 'popover'
                this.dataset.placement = 'bottom'
                this.dataset.content = data[emslink]
            }
        });

        $('[data-toggle="popover"]').click(function (e) {
            e.preventDefault()
        }).popover({
            trigger: 'focus',
            template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-body"></div></div>',
            html: true
        })
    }).fail(function () {
        console.log('error with lexicon');
    });
    /* END lexicon*/

    if ( window.location.hash ) {
        let target = $(window.location.hash)
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']')

        if (target.length) {
            console.log(target);

            $('html, body').animate({
                scrollTop: target.offset().top - 40
            }, 400, function () {
                // Callback after animation
                // Must change focus!
                target.focus()
                if (target.is(':focus')) { // Checking if the target was focused
                    return false
                } else {
                    target.attr('tabindex', '-1') // Adding tabindex for elements not focusable
                    target.focus() // Set focus again
                }
            })
        }
    }



    const $overlay = $('<div>', {id: 'backdrop-menu'})
    $('#main-nav .dropdown').on('show.bs.dropdown', function () {
        $('body').addClass('menu-open').append($overlay)
    }).on('hide.bs.dropdown', function () {
        $('body').removeClass('menu-open')
        $overlay.remove()
    })

    $('#quick-access').submit(function (e) {
        e.preventDefault()
        window.location = $(this).find(':selected').val()
    })

})
